import { RumEvent } from '@datadog/browser-rum';

const trustedDomains = [
  '.strider.ag',
  '.cropwise.com',
  '.syngentadigital.co.uk',
  '.us-west-2.amazonaws.com',
];

const IGNORED_ERROR_PATTERNS = [/ResizeObserver loop/i];

export const isTrustedDomain = (url: string) => {
  try {
    const { hostname } = new URL(url);

    return trustedDomains.some((domain) => hostname.endsWith(domain));
  } catch {
    return false;
  }
};

export const handleBeforeSend = (event: RumEvent) => {
  if (event.type === 'resource' && !isTrustedDomain(event.resource.url)) {
    return false;
  }

  if (event.type === 'error') {
    const message = event.error?.message ?? '';
    if (IGNORED_ERROR_PATTERNS.some((pattern) => pattern.test(message))) {
      return false;
    }
  }

  return true;
};
